<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <app-input
          @input.native="onGroupsSearch"
          v-model="search"
          class="input--200"
          type="search"
          placeholder="Search by group name"
          name="search"
        />
      </app-cells>
      <div v-for="safari_table_item of safari_table" :key="safari_table_item.name" class="safari-block">
        <app-cells>
          <h2 class="title">{{ safari_table_item.name }}</h2>
          <div v-if="safari_table_item.today" class="status-title" :style="{ 'backgroundColor': '#77b017' }">Today</div>
        </app-cells>
        <v-client-table
          :data="safari_table_item.items"
          :columns="table.columns"
          :options="table.options"
          class="table-default"
          :class="{ 'table-default--loading': table_preloader }"
        >
          <template #h__name>
            <div class="table-default__left">Name</div>
          </template>
          <template #h__clients_itinerary>
            <div class="table-default__left">Itinerary</div>
          </template>
          <template #h__start_from>
            <div class="table-default__left">Start from</div>
          </template>
          <template #h__finish_at>
            <div class="table-default__left">Finish at</div>
          </template>
          <template #name="{ row }">
            <div class="table-default__left">
              <router-link
                :to="{ name: 'safari-groups-detail-clients', params: { id: row.id } }"
                class="table-default__link-border"
              >
                {{ row.name }}
              </router-link>
            </div>
          </template>
          <template #type="{ row }">
            <span class="status-tag" :style="{ 'backgroundColor': row.type.color || '#8a8a8a' }">
              {{ row.type ? row.type.name : '-' }}
            </span>
          </template>
          <template #clients_itinerary="{ row }">
            <div class="table-default__controls table-default__left">
              <a
                :href="`https://tz.altezza.travel/itinerary/${row.itinerary_hash[0]}`"
                target="_blank"
                class="table-default__activity table-default__activity--itinerary"
                :class="{'table-default__activity--active': row.itinerary_hash.length === 1}"
              />
              <button
                v-if="row.reservation"
                @click="onDownloadFile(row)"
                class="table-default__activity table-default__activity--driver"
                :style="{ backgroundColor: !row.reservation.itinerary_completed && !row.reservation.itinerary_verified ? '' : row.reservation.itinerary_completed && !row.reservation.itinerary_verified ? '#f0c427' : '#77b017' }"
              ></button>
              <span v-if="row.short_itinerary">{{ row.short_itinerary }}</span>
            </div>
          </template>
          <template #number_of_clients="{ row }">
          <span
            v-tooltip="{ content: clientTableList(row.clients), placement: 'top-start', offset: 10, html: true }"
            :style="{cursor: 'pointer'}"
          >
            {{ row.number_of_clients }}
          </span>
          </template>
          <template #tour_start="{ row }">
            {{ dateFormatTable(row.tour_start) }}
          </template>
          <template #tour_end="{ row }">
            {{ dateFormatTable(row.tour_end) }}
          </template>
          <template #start_from="{ row }">
            <div class="table-default__left">{{ row.start_from?.short_name || '-' }}</div>
          </template>
          <template #finish_at="{ row }">
            <div class="table-default__left">{{ row.finish_at?.short_name || '-' }}</div>
          </template>
        </v-client-table>
      </div>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table_length" :page="pagination.page" :limit="40" />
      </app-cells>
    </template>
  </div>
</template>

<script>
import { getSafariGroupsByDates } from '@/http'
import debounce from 'lodash/debounce'
import { format, parse } from 'date-fns'
import axios from 'axios'

export default {
  name: 'SafariGroupsArchiveList',
  data() {
    return {
      is_loaded: false,
      search: null,
      safari_table: [],
      table_length: 0,
      table: {
        items: [],
        columns: ['name', 'number_of_clients', 'cars_required', 'type', 'clients_itinerary', 'tour_start', 'tour_end', 'duration', 'start_from', 'finish_at'],
        options: {
          headings: {
            'name': 'Name',
            'number_of_clients': 'Pax',
            'cars_required': 'Cars',
            'type': 'Type',
            'clients_itinerary': 'Itinerary',
            'tour_start': 'Start',
            'tour_end': 'Finish',
            'duration': 'Days',
            'start_from': 'Start from',
            'finish_at': 'Finish at',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader: false,
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    clientTableList(clients) {
      let result = ''
      for (const key in clients) {
        result += `${clients[key].first_name} ${clients[key].last_name}<br>`
      }
      return result
    },
    onClickPagination(page) {
      this.table_preloader = true
      this.pagination.page = page
      this.fetchItems()
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : ''
    },
    dateFormatTable(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM') : '-'
    },
    fetchItems() {
      const params = {
        page: this.pagination.page,
        page_size: 40,
        search: this.search,
        category: 'past',
        group_by: 'tour_start',
        range_type: 'month',
        ordering: '-tour_start'
      }
      getSafariGroupsByDates(params)
        .then(res => {
          this.safari_table = res.data.results
          this.pagination.pages = res.data.pages
          this.pagination.count = res.data.count
          this.table_length = 0
          res.data.results.forEach(item => {
            this.table_length += item.items.length
          })
          this.is_loaded = true
          this.table_preloader = false
        })
    },
    onGroupsSearch() {
      this.table_preloader = true
      this.searchGroups(this)
    },
    searchGroups: debounce(vm => {
      vm.pagination.page = 1
      vm.fetchItems()
    }, 350),
    onDownloadFile(data) {
      this.file_loading = true
      axios.get(data.driver_itinerary.file, { responseType: 'blob' })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          const extension = data.driver_itinerary.file_name.split('.').pop()
          link.href = url
          link.setAttribute('download', `Driver itinerary ${data.name} ${this.dateFormat(data.tour_start)}-${this.dateFormat(data.tour_end)}.${extension}`)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
          this.file_loading = false
        })
    },
  }
}
</script>

<style lang="sass" scoped>
.safari-block
  margin-bottom: 30px
</style>
